import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { setLanguage } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import {
  getUserInfo,
  getCustomForm,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import {
  generateCustomForm,
  attachCustomFormTools,
} from "/WebInterface/new-ui/modules/custom-form/custom-form.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import { postCustomForm } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";

const showWelcomeForm = async (customForm) => {
  const formName = customForm.name;

  const formContent = generateCustomForm(customForm);

  const messageForm = _$("#messageForm").el();
  messageForm.innerHTML = formContent;

  attachCustomFormTools(messageForm, formName);
};

const RenderMessageForm = () => {
  getCustomForm("messageForm")
    .then(showWelcomeForm)
    .catch((error) => {
      console.log(error);
    });
};

const getFriendlyErrorLines = (rawError) => {
  let msg =
    (typeof rawError === "string" && rawError) ||
    rawError?.message ||
    "Failure";

  try {
    msg = decodeURIComponent(msg);
  } catch (e) {}
  msg = msg.replace(/\+/g, " ");

  const lines = msg
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l && !/^PASS_/i.test(l) && !/^OK$/i.test(l))
    .map((l) => l.replace(/^Failure[:\-]?\s*/i, "").trim());

  if (!lines.length) {
    return ["Failure"];
  }

  return lines;
};

const handleSubmitButtonClick = () => {
  const messageForm = _$("#messageForm").el();
  const validateFields = validate(messageForm, false);
  if (validateFields.length === 0) {
    const messageFormLoader = new Loader({ parentElement: "#signupFormCard" });
    const data = utils.serializeInputs(messageForm);
    postCustomForm({ ...data, meta_form_name: "messageForm" })
      .then((response) => {
        _$(".registration-completed").removeClass("is-hidden");
        _$(".registration-failed").addClass("is-hidden");
      })
      .catch((error) => {
        _$(".registration-failed").removeClass("is-hidden");
        _$(".registration-completed").addClass("is-hidden");

        const failureText = _$("#registrationFailureMessage");
        if (failureText && failureText.el()) {
          const lines = getFriendlyErrorLines(error);
          const el = failureText.el();
          el.innerHTML = lines.map((l) => utils.sanitizePure(l)).join("<br />");
        }

        const failedPanel = _$(".registration-failed").el();
        if (failedPanel && typeof failedPanel.scrollIntoView === "function") {
          failedPanel.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .finally(() => {
        messageFormLoader.deleteLoader();
      });
  }
};

const applyCustomizations = () => {
  const login_page_default_theme =
    window.customizations?.login_page_default_theme;
  const brandingImagePath =
    window.brandingImagePath && utils.sanitizePure(window.brandingImagePath);

  if (
    login_page_default_theme ||
    typeof login_page_default_theme === "string"
  ) {
    const [theme, hidePicker] = login_page_default_theme.split("-");
    _$("[data-theme]").attr("data-theme", theme);
    localStorage.setItem("data-theme", theme);
    if (hidePicker) {
      _$("w-theme").remove();
    }
  }

  if (window.customizations?.login_page_default_language) {
    if (window.customizations?.login_page_save_languages_selection === "true") {
      setLanguage(
        localStorage.getItem("selected-language") ||
          window.customizations?.login_page_default_language
      );
    } else {
      setLanguage(window.customizations?.login_page_default_language);
    }
  }

  if (window.customizations?.login_page_show_language_selection === "false") {
    _$("w-language").remove();
  }

  if (window.customizations?.login_page_languages_to_show) {
    utils.filterLanguagesToShow(
      window.customizations?.login_page_languages_to_show
    );
  }

  if (window.customizations?.login_page_column_style === "single") {
    _$(".auth-banner-container").remove();
  }

  if (window.customizations?.login_page_column_style === "double-reverse") {
    _$("#page-columns").addClass("is-flex-direction-row-reverse");
  }

  if (window.customizations?.login_page_save_languages_selection === "true") {
    window.addEventListener("languageChanged", (e) => {
      localStorage.setItem("selected-language", e.detail.language);
    });
  }

  const authBanner = _$("#auth-banner");
  const currentSrc = authBanner?.attr("src");
  authBanner.attr("src", brandingImagePath || currentSrc);
};

const configureElectronApp = () => {
  const isElectron = utils.isElectron();

  if (isElectron) {
    _$(".electron-app-remove").remove();
  }
};

function init() {
  // Get user info
  getUserInfo()
    .then((res) => {
      RenderMessageForm();
    })
    .catch(() => {
      location.href = "/WebInterface/login.html";
    });
}

//On DOM Ready
_$("body").ready(() => {
  configureElectronApp();
  init();
  applyCustomizations();

  _$("#backToLogin").on("click", () => {
    location.href = "/WebInterface/login.html";
  });

  _$("#sign-up-button").on("click", handleSubmitButtonClick);
});
